export default "__VITE_ASSET__Djo2_k0F__"